export function isIPad(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || '';
  const isIPadUA = /iPad/.test(ua);
  const n = navigator as Navigator & { maxTouchPoints?: number };
  const isIPadOS =
    // iPadOS sometimes reports as Mac but with touch
    (navigator.platform === 'MacIntel' ||
      // newer Safari drops platform—fall back to UA
      /Mac OS X/.test(ua)) &&
    typeof n.maxTouchPoints === 'number' &&
    n.maxTouchPoints > 1;
  return isIPadUA || isIPadOS;
}
